import "./campaign.scss";

import { SphereRedeemItemProvider } from "@domain/reward/sphere-redeem-item/sphere-redeem-item.context";
import { Outlet } from "react-router-dom";

import { FilterCampaignProvider } from "./filter-campaign/filter-campaign.context";

export function Campaign() {
  return (
    <div id="ShellCampaign" className="campaign">
      <FilterCampaignProvider>
        <SphereRedeemItemProvider>
          <Outlet />
        </SphereRedeemItemProvider>
      </FilterCampaignProvider>
    </div>
  );
}

export default Campaign;
